/**
 * 시작/종료 범위 역전 방지 — 사전순=시간순인 포맷(`yyyy-MM-dd`·`yyyy-MM`·`yyyy`)에서 동작.
 * 방금 바꾼 쪽(`changed`)을 유지하고 반대쪽을 그 값으로 맞춰 항상 `start ≤ end` 를 보장한다.
 * 한쪽이 비어있으면(미입력) 정규화 없이 통과. 필터(연도·날짜) 시작/종료 setter 공용 — 이벤트·통계 등.
 *
 * 예) clampDateRange('2024', '2020', 'start') → { start: '2024', end: '2024' }
 *     clampDateRange('2024', '2020', 'end')   → { start: '2020', end: '2020' }
 */
export function clampDateRange(
  start: string,
  end: string,
  changed: 'start' | 'end',
): { start: string; end: string } {
  if (!start || !end || start <= end) return { start, end };
  return changed === 'start' ? { start, end: start } : { start: end, end };
}
